import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CircleNotch } from "@phosphor-icons/react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-loading">
        <CircleNotch size={40} className="animate-spin text-[#2E2E2E]" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  return children;
}
